export const changePwdErrorInformation: { [id: string]: string } = {
  401: "Invalid access token. Please log back again",
};
